import React, { useState } from 'react'
import { CRow, CCol, CFormInput, CLoadingButton, CAlert } from '@coreui/react-pro'
import { useParams } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'

const ImportScorecardFromUrl = (props) => {
  const { fixtureId, teamId } = useParams()

  const [playhqUrl, setPlayhqUrl] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState([])

  const handleImport = async () => {
    if (!playhqUrl) {
      ToastComponent('Please enter PlayHQ game URL', 'error')
      return
    }

    // Extract game ID from URL
    const match = playhqUrl.match(/game-centre\/([a-z0-9]+)/i)

    if (!match) {
      ToastComponent('Invalid PlayHQ URL', 'error')
      return
    }

    const gameId = match[1]

    setIsLoading(true)
    setErrors([])

    try {
      const res = await ScorecardService.importScorecardFromUrl({
        fixtureId,
        teamId,
        gameId,
      })

      if (res.success) {
        ToastComponent(res.message || 'Scorecard imported successfully', 'success')
        setPlayhqUrl('')
        if (props.fetchData) {
          props.fetchData(props.defaultInning)
        }
      } else {
        setErrors(res.errors || ['Import failed'])
      }
    } catch (err) {
      console.error(err)
      setErrors(['Failed to import scorecard from URL'])
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {errors.map((e, i) => (
        <CAlert key={i} color="danger">
          {e}
        </CAlert>
      ))}

      <CRow className="mb-4">
        <CCol md={10}>
          <label className="form-label">PlayHQ Scorecard URL</label>
          <CFormInput
            type="text"
            placeholder="Paste PlayHQ game-centre URL here"
            value={playhqUrl}
            onChange={(e) => setPlayhqUrl(e.target.value)}
          />
        </CCol>

        <CCol md={2} className="d-flex align-items-end">
          <CLoadingButton
            color="primary"
            variant="outline"
            loading={isLoading}
            onClick={handleImport}
            className="w-100"
          >
            Import
          </CLoadingButton>
        </CCol>
      </CRow>
    </>
  )
}

export default ImportScorecardFromUrl
